import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
/** Свойства показетеля государственной программы */
let PitActivityStateProgramIndicatorValues = class PitActivityStateProgramIndicatorValues {
    get year() {
        return this._year;
    }
    set year(value) {
        this._year = value;
    }
    get planFact() {
        return this._planFact;
    }
    set planFact(value) {
        this._planFact = value;
    }
    get amount() {
        return this._amount;
    }
    set amount(value) {
        this._amount = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "year", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityStateProgramIndicatorValues.prototype, "_year", void 0);
tslib_1.__decorate([
    jsonMember({ name: "indicatorType", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityStateProgramIndicatorValues.prototype, "_planFact", void 0);
tslib_1.__decorate([
    jsonMember({ name: "amount", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitActivityStateProgramIndicatorValues.prototype, "_amount", void 0);
PitActivityStateProgramIndicatorValues = tslib_1.__decorate([
    jsonObject
], PitActivityStateProgramIndicatorValues);
export { PitActivityStateProgramIndicatorValues };
